import React from 'react';
import { BaSeForbiddenPage } from '@base/react';
import './forbidden.scss';

const Forbidden = () => {

  return (
    <BaSeForbiddenPage />
  )
}

export default Forbidden;